import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { ISearchVehiclesResponse, SearchVehiclesResponseExtensionClass } from './search-vehicles';

function searchVehiclesByRegIdQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

function searchVehiclesByRegIdInput(regId: string): IDataServiceRequest {
    const query = searchVehiclesByRegIdQuery();
    return query.createDataServiceRequestForOperation(
        'SearchByRegId',
        false,
        SearchVehiclesResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'ISearchVehiclesResponse' },
        {
            regId: regId
        }
    );
}

export function searchVehiclesByRegIdAsync(context: IContext, regId: string): AsyncResult<ISearchVehiclesResponse> {
    const request = searchVehiclesByRegIdInput(regId);
    return callActionOrExecute<ISearchVehiclesResponse>(request, context.callerContext);
}
